import React from "react";

import warningIcon from "../img/warning-icon.svg"

const ErrorMessage = ({ close, message, email, secondMessage, buttonText, link, button, icon, onClick, }) => {
  return (
    <div className="container-error-message">
      <img src={warningIcon} alt="Warning Icon" height="48px" width="48px" />
      <div className="text-error d-block">
        <p style={{ margin: '0' }}>{message}</p>
        <p style={{ margin: '0' }}>{email}</p>
        <p style={{ margin: '0' }}>{secondMessage}</p>
        {!button ? null : <div className="boxInputSignup" style={{ justifyContent: 'center' }}>
          <a href={link}>
            <button
              style={{ margin: '1em 0 0 0' }}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className="orange-button"
              onClick={onClick}
            >
              {buttonText}
            </button>
          </a>
        </div>}
      </div>
    </div>
  );
};

export default ErrorMessage;
